/**
 * Table Explorer Workspace Type
 *
 * This module registers the table explorer with the workspace registry.
 * Import this module to ensure the table explorer is available.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { TableExplorerTab } from './components/TableExplorerTab';

// Register the table explorer component
registerWorkspaceComponent('table-explorer', TableExplorerTab);

// Re-export components for direct use
export { TableExplorerTab } from './components/TableExplorerTab';
export { TableExplorerToolbar } from './components/TableExplorerToolbar';
export { TableExplorerStatusBar } from './components/TableExplorerStatusBar';
export { TableExplorerGrid } from './components/TableExplorerGrid';
export { TableExplorerDialog } from './components/TableExplorerDialog';

// Re-export hooks
export { useTableData } from './hooks/useTableData';

// Re-export store
export { useTableExplorerDialogStore } from './store/tableExplorerDialogStore';
